import RadioGroup from './radio-group.vue';
import { withInstall, WithInstallType } from '../shared';

const _RadioGroup: WithInstallType<typeof RadioGroup> = withInstall(RadioGroup);
export default _RadioGroup;
